// spec-reporting-hierarchy: a team invite link (/welcome?team=&invite=) opened by someone who
// must sign in by email first. The link is parked in localStorage (never in the verification
// email) and picked up once /users/confirm-identity succeeds (Verify.vue). localStorage, not
// sessionStorage, because the sign-in email is usually opened in a new tab; it expires with
// the invite token (72h) so a stale link is never picked up later.
const KEY = 'teamwrkr-pending-team-link'
const TTL_MS = 72 * 60 * 60 * 1000
// spec-admin-gated-company-access: an access-request decision link (/team-confirmation?access=<id>)
// opened while signed out is parked under its OWN key, so it never overwrites a pending team link.
const ACCESS_KEY = 'teamwrkr-pending-access-link'

export function savePendingTeamLink({ team, invite } = {}) {
  if (!team) return
  try {
    localStorage.setItem(KEY, JSON.stringify({ team, invite: invite || null, savedAt: Date.now() }))
  } catch (err) {
    // Storage blocked (private mode etc.): the link just isn't carried through.
  }
}

// Returns { team, invite } once and clears it, or null (also null once expired).
export function takePendingTeamLink() {
  try {
    const raw = localStorage.getItem(KEY)
    localStorage.removeItem(KEY)
    const parsed = raw ? JSON.parse(raw) : null
    if (!parsed?.team) return null
    if (!parsed.savedAt || Date.now() - parsed.savedAt > TTL_MS) return null
    return { team: parsed.team, invite: parsed.invite || null }
  } catch (err) {
    return null
  }
}

export function savePendingAccessLink(access) {
  if (!access || typeof access !== 'string') return
  try {
    localStorage.setItem(ACCESS_KEY, JSON.stringify({ access, savedAt: Date.now() }))
  } catch (err) {
    // Storage blocked: the link just isn't carried through.
  }
}

// Returns the parked access-request id once and clears it, or null (also null once expired).
export function takePendingAccessLink() {
  try {
    const raw = localStorage.getItem(ACCESS_KEY)
    localStorage.removeItem(ACCESS_KEY)
    const parsed = raw ? JSON.parse(raw) : null
    if (!parsed?.access) return null
    if (!parsed.savedAt || Date.now() - parsed.savedAt > TTL_MS) return null
    return parsed.access
  } catch (err) {
    return null
  }
}

// Called on logout so a parked link never carries over to the next person on a shared browser.
export function clearPendingTeamLink() {
  try {
    localStorage.removeItem(KEY)
    localStorage.removeItem(ACCESS_KEY)
  } catch (err) {
    // Storage blocked: nothing was parked.
  }
}

export function teamConfirmationRoute({ team, invite }) {
  return { path: '/team-confirmation', query: invite ? { team, invite } : { team } }
}

export function accessConfirmationRoute(access) {
  return { path: '/team-confirmation', query: { access } }
}
